__turbopack_context__.v({
  "dropdown": "DropdownTags-module__nR2y7q__dropdown",
  "fadeIn": "DropdownTags-module__nR2y7q__fadeIn",
  "icon": "DropdownTags-module__nR2y7q__icon",
  "label": "DropdownTags-module__nR2y7q__label",
  "menu": "DropdownTags-module__nR2y7q__menu",
  "open": "DropdownTags-module__nR2y7q__open",
  "selected": "DropdownTags-module__nR2y7q__selected",
  "svgIcon": "DropdownTags-module__nR2y7q__svgIcon",
});
